import AbstractWatchableBrickConfig from './abstract-watchable-brick-config';

export default class WidgetV2BrickConfig extends AbstractWatchableBrickConfig {
  constructor(params) {
    super(params);

    this.buildWithIframe = true;
    this.partnerAssetId = params.partnerAssetId;
    this.useLatestEpisode = params.useLatestEpisode === 'true';
    this.height = params.height;
    this.width = params.width;
  }

  isLatestEpisode() { return this.useLatestEpisode; }

  toQueryParamObject() {
    const queryParams = super.toQueryParamObject();

    if (this.partnerAssetId) queryParams.partnerAssetId = this.partnerAssetId;
    if (this.useLatestEpisode) queryParams.useLatestEpisode = this.useLatestEpisode;
    if (this.height) queryParams.height = this.height;
    if (this.width) queryParams.width = this.width;

    return queryParams;
  }
}



// WEBPACK FOOTER //
// ./src/models/widget-v2-brick-config.js